import React, {useMemo, useState} from 'react';
import ModalHeader from './components/ModalHeader'
import Schedule from './pages/schedule'
import OrderUpdate from './pages/orderUpdate'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const [orderRef, setOrderRef] = useState(() => urlParams.get('order'))
  const [storeId, setStoreId] = useState(() => urlParams.get('store'))
  const [appointmentId, setAppointmentId] = useState(() => urlParams.get('appointment'))
  const [view, setView] = useState(() => ({ screen: 'main', selectedAppointment: {} }))
  const [settings, setSettings] = useState()
  const [themeColor, setThemeColor] = useState('#333')
  const [categoryOptions, setCategoryOptions] = useState([])
  // useEffect(() => {
  //   (async function () {
  //     const test = await fetch(`${process.env.REACT_APP_SERVER}/app?shop=schedule-test.myshopify.com`)
  //     const testJson = await test.json()
  //     console.log("SERVER:", testJson)

  //     const shopifyTest = await fetch(`${process.env.REACT_APP_SERVER}/appointment-list?shop=schedule-test.myshopify.com`)
  //     const shopifyTestJson = await shopifyTest.json()
  //     console.log("SHOPIFY:", shopifyTestJson)
  //   })()
  // }, [])

  useMemo(async () => {
    // const shop = window.location.ancestorOrigins[0].replace('https://', '')
    // const shop =  window.parent.location.host
    const response = await fetch(`${process.env.REACT_APP_SERVER}/shop-settings?shop=${storeId}`)
    const settingsJson = await response.json()
    const settings = settingsJson.data.settings[0]

    // Set theme color
    document.documentElement.style.setProperty('--mainColor', settings?.theme_color_hex)

    // Set category options
    const options = settings.categories ? JSON.parse(settings.categories).map(cat => ({ value: cat.toLowerCase(), label: cat })) : []

    setSettings(settings)
    setCategoryOptions(options)
    setThemeColor(settings?.theme_color_hex)
  }, [])

    // Change modal view
    const handleSetView = (screen, selectedAppointment = {}) => {
      setView(() => ({ screen, selectedAppointment }))
    }


    // Close modal
    const handleClose = () => {
      window.top.postMessage(
        {
          ctSchedule: {
            closeModal: true
          }
        },
        '*'
      )
      setOrderRef()
      setAppointmentId()
      setTimeout(() => {
        handleSetView('main')
      }, 500)
    }

  return (
    <div className="App">
      <div className="ct-modal">
        <ModalHeader handleClose={handleClose} view={view} />
        {!orderRef && <Schedule view={view} handleSetView={handleSetView} themeColor={themeColor} settings={settings} categoryOptions={categoryOptions} appointmentId={appointmentId} setAppointmentId={setAppointmentId} /> }
        {orderRef && <OrderUpdate handleSetView={handleSetView} orderRef={orderRef} /> }
      </div>
    </div>
  );
}

export default App;
